import { Controller } from "@hotwired/stimulus";

const NO_SERVICES_MESSAGE =
  "We're sorry, we don't currently offer services in the location you have entered. If you'd like help understanding your options, our team is available at <strong><a href='tel:1800071176' class='underline'>1800 071 176</a></strong>.";
const CREMATION_ONLY_MESSAGE =
  "Your loved one is in a location where we only offer cremations without a service.";
const LOADING_MESSAGE =
  "Please wait... We're checking which services are available for the address you entered.";

export default class extends Controller {
  static targets = ["messageBox", "message"];

  static values = {
    brand: String,
  };

  connect() {
    this.checkInitialPostcode();
    this.addEventListeners();
  }

  get radios() {
    return this.element.querySelectorAll("input[type='radio']");
  }

  get postcodeField() {
    return this.element.querySelector("input[name*='[postcode]']");
  }

  addEventListeners() {
    if (this.postcodeField) {
      this.postcodeField.addEventListener("change", (event) => {
        const postcode = event.target.value;
        if (postcode) {
          this.radios.forEach((radio) => {
            if (this.brandValue === "bare") {
              radio.checked = false;
            }
          });
          this.checkServiceAvailability(postcode);
        }
      });
    }
  }

  checkInitialPostcode() {
    if (this.postcodeField && this.postcodeField.value) {
      this.checkServiceAvailability(this.postcodeField.value);
    } else {
      this.setRadioState(false);
    }
  }

  setRadioState(enabled, { only } = {}) {
    if (this.brandValue === "bare") {
      this.radios.forEach((radio) => {
        const isEnabled = only ? radio.value === only : enabled;
        radio.disabled = !isEnabled;
        radio.required = isEnabled;
      });
    }
  }

  // TODO: we want to avoid calling API's from the JS and use turbo streams instead.
  async checkServiceAvailability(postcode) {
    this.toggleMessage(true, LOADING_MESSAGE);

    try {
      const response = await fetch(
        `/at_need/product_info?postcode=${encodeURIComponent(postcode)}`,
      );
      const data = await response.json();

      if (response.ok) {
        this.handleServiceAvailability(data);
      } else {
        this.handleNoServices();
      }
    } catch (error) {
      console.error("Error checking service availability:", error);
      this.handleNoServices();
    }
  }

  handleServiceAvailability(data) {
    if (data.cremation && data.burial_funeral_memorial) {
      this.setRadioState(true);
      this.toggleMessage(false);
    } else if (data.cremation) {
      this.setRadioState(true, { only: "cremation" });
      this.toggleMessage(true, CREMATION_ONLY_MESSAGE);
    } else {
      this.handleNoServices();
    }
  }

  handleNoServices() {
    this.setRadioState(false);
    this.toggleMessage(true, NO_SERVICES_MESSAGE);
  }

  toggleMessage(visible, html = "") {
    if (!this.hasMessageBoxTarget) return;

    this.messageBoxTarget.classList.toggle("hidden", !visible);
    this.messageTarget.innerHTML = html;
  }
}
